import * as React from "react";
import Rating, { IconContainerProps, RatingProps } from "@mui/material/Rating";

import { FaFaceAngry } from "react-icons/fa6";
import { FaFaceFrown } from "react-icons/fa6";
import { FaFaceMeh } from "react-icons/fa6";
import { FaFaceSmile } from "react-icons/fa6";
import { FaFaceLaugh } from "react-icons/fa6";
import { WcStack } from "../../layout";
import { SxProps, Theme } from "@mui/material";

export interface WcColourRatingObject {
  [index: number]: {
    string;
  };
}

const customIcons: {
  [index: string]: {
    icon: React.ReactElement;
    label: string;
  };
} = {
  1: {
    icon: <FaFaceAngry />,
    label: "Very Dissatisfied",
  },
  2: {
    icon: <FaFaceFrown />,
    label: "Dissatisfied",
  },
  3: {
    icon: <FaFaceMeh />,
    label: "Neutral",
  },
  4: {
    icon: <FaFaceSmile />,
    label: "Satisfied",
  },
  5: {
    icon: <FaFaceLaugh />,
    label: "Very Satisfied",
  },
};

const WcSmileyIconContainer = (props: IconContainerProps) => {
  const { value, ...other } = props;
  return (
    <WcStack padding={1} {...other}>
      {customIcons[value].icon}
    </WcStack>
  );
};

export type WcSmileyProps = RatingProps & {
  colors?: WcColourRatingObject;
};

export const WcSmiley = ({ value, colors, ...others }: WcSmileyProps) => {
  const [hover, setHover] = React.useState(-1);
  return (
    <Rating
      defaultValue={3}
      name="highlight-selected-only"
      IconContainerComponent={WcSmileyIconContainer}
      getLabelText={(val: number) => customIcons[val].label}
      highlightSelectedOnly
      value={value || 3}
      sx={{ color: colors[value] || "", ":hover": { color: colors[hover] } }}
      onChangeActive={(event, newHover) => {
        setHover(newHover);
      }}
      {...others}
    />
  );
};

export type WcSmileySingleIconProps = IconContainerProps & {
  fontSize?: string | number;
  sx?: SxProps<Theme>;
};

export const WcSmileySingleIcon = ({ fontSize, sx, ...others }: WcSmileySingleIconProps) => (
  <WcStack sx={[{ fontSize: fontSize ? fontSize : "20px" }, ...(Array.isArray(sx) ? sx : [sx])]}>
    {WcSmileyIconContainer({ ...others })}
  </WcStack>
);

export default WcSmiley;
